// The first visit's Highlights (ba-web; the owner's ask of 2026-10-02, "cool stuff in the showcase I'm not seeing how to view in
// the app", the lead's go of 10-06): one exact state per scene, in the scenes' order, taken from the Gallery's own cards
// (src/data/gallery.json, state 'app'). features/Highlights.tsx shows them as a strip over the root page on a visitor's first
// visit of a session, so the showcase's best interactive states are one tap away. test/highlights.test.ts holds the list to the
// manifest: every id exists, opens exactly in the app, and names its scene once, in SCENARIOS order.
import { SCENARIOS, type ScenarioId } from '../scenarios/index.ts';

export const HIGHLIGHTS: readonly string[] = [
  'pot-push', // Explore: the Powers of Ten dive, from the cortex to one neuron
  'flow-cfd', // Blood flow: 20,000 tracers ride the heartbeat
  'drop-flow-engine-ixi165-sd', // Stroke: a spreading depolarization crosses one person's cortex
  'drop-app-seizure-bigbrain-17s', // Seizure: a seizure lights BigBrain's own cortex
  'drop-app-neurons-h01-activity', // Neurons: H01's real wiring, firing
  'drug-receptor-map', // Drugs: 5-HT2A engagement after 200 µg of LSD
  'drop-mind-live-vision-v1', // Mind: a picture on visual cortex
  'drop-stim-ixi165-tms-c3-hero-v1', // Stimulate: TMS on the hero cortex
  'drop-lifetime-fetal-atlas-v1', // Lifetime: a cortex takes shape
];

/** The session flag (sessionStorage, as the 2D notice's): the strip was dismissed or used, so it stays away this session. */
export const HIGHLIGHTS_SEEN = 'ba-highlights-seen';

/** The scene a card's first link opens, read from its query, or null. */
export function sceneOfLink(q: string): ScenarioId | null {
  const scene = new URLSearchParams(q.startsWith('?') ? q.slice(1) : q).get('scene');
  return scene && SCENARIOS.some((sc) => sc.id === scene) ? (scene as ScenarioId) : null;
}

/**
 * Whether the strip opens on this page load: the bare root address, with nothing in it at all (a first visitor's arrival),
 * or `highlights=1` (a link to it, and the checks); never a deep link, which shows its own state, never `highlights=0`, and
 * never again in a session once it was dismissed or used, unless asked for by `highlights=1`.
 */
export function highlightsWanted(search: string, seen: boolean): boolean {
  const q = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const asked = q.get('highlights');
  if (asked === '0') return false;
  if (asked === '1') return true;
  return [...q.keys()].length === 0 && !seen;
}
